module.exports = __webpack_public_path__ + "static/clients-shaking-hands-desktop.b0c7fda2.webp";